import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";

const Dropdown = ({ options, variant = "standard", label, name, value, onChange, showSelect = true, required }) => {
  const labelId = `${name}-label`;

  return (
    <FormControl fullWidth variant={variant} required={required}>
      <InputLabel id={labelId}>
        {label}
        {required}
      </InputLabel>

      <Select
        labelId={labelId}
        id={`${name}-select`}
        name={name}
        value={value}
        onChange={onChange}
        displayEmpty

      >
        {showSelect && (
          <MenuItem disabled value={null}>
            Select
          </MenuItem>
        )}
        {options?.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
